import type { Feature } from '@luna/gatekeeper';

export const cardInsurance: Feature = {
    enabled: false,
    _description: 'Enables the payment protection insurance feature',
};
